<template>
    <tr class="t-border-b hover:t-bg-orange-100 t-bg-gray-100">
		<td class="t-p-3 t-px-5">{{ offer.id }}</td>
        <td class="t-p-3 t-px-5">
			Pickup: <strong>{{ offer.pickupArea.data.name }} (#{{ offer.pickupArea.data.id}})</strong><br>
			Delivery: <strong>{{ offer.deliveryArea.data.name }} (#{{ offer.deliveryArea.data.id }})</strong>
		</td>
        <td class="t-p-3 t-px-5">${{ offer.rate }}/{{ rateType }}</td>
        <td class="t-p-3 t-px-5">${{ offer.min_charge }}</td>
        <td class="t-p-3 t-px-5">
            Cut-off: <strong>{{ cutOffTime }}</strong>
            <br>{{ offer.human_service_level }}
        </td>
        <td class="t-p-3 t-px-5">
            <li :key="packageType.id" v-for="packageType in offer.packageTypes.data">
				{{ packageType.name }}
			</li>
        </td>
        <td class="t-p-3 t-px-5">{{ answer }}</td>
        <td class="t-p-3 t-px-5">
			<!--<button @click="$emit('edit')" class="btn btn-primary btn-sm mb-1"><i class="fa fa-pencil"></i></button>-->
            <router-link :to="{name: 'editFixedRatesForm', params: {id: offer.id}}">
                <button class="t-bg-blue-500 hover:t-bg-blue-700 t-text-white t-py-1 t-px-2 t-m-1 t-rounded"><i class="fa fa-pencil"></i></button>
            </router-link>
			<button @click="$emit('delete')" class="t-bg-red-500 hover:t-bg-red-700 t-text-white t-py-1 t-px-2 t-m-1 t-rounded"><i class="fa fa-trash"></i></button>
		</td>
    </tr>
</template>

<script>
    export default {
        name: 'fixed-rate-item',
        props: ['offer'],

        computed: {
            answer() {
                if (this.offer.live) {
                    return 'Yes';
                }
                
                return 'No';
            },

			rateType() {
				if (this.offer.rate_calculation_type == "PER_TONNE") {
					return "per tonne";
				} else if (this.offer.rate_calculation_type == "PER_TONNE_KM") {
					return "per tonne Km";
				} else {
					return "per package";
				}
			},

			cutOffTime() {
				return moment(this.offer.cutoff_time, "kk:mm").format('h:mma')
			}
        }
    }
</script>